<template>
  <div class="mainLoader">
    <div>
      <img class="loader__logo" src="@/assets/logo-big.png" alt="Logo">
      <div class="loader__bar" id="loader-bar">
        <span class="loader__text" id="loader-text">{{ $t('loader.l1') }}</span>
        <span class="loader__bar--1"></span>
        <span class="loader__bar--2"></span>
        <span class="loader__bar--3"></span>
        <span class="loader__bar--4"></span>
        <span class="loader__bar--5"></span>
        <span class="loader__bar--6"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoaderComponent',
}
</script>

<style scoped>

.mainLoader {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 1000000000;
  background-color: #fff;
}

.loader__logo {
  margin-bottom: 15px;
  width: 250px;
}

.loader__text {
  font-family: "Connections", sans-serif;
  font-weight: bold;
  font-size: 17px;
  margin-bottom: 5px;
  display: block;
}

.loader__bar--1, .loader__bar--2, .loader__bar--3, .loader__bar--4, .loader__bar--5, .loader__bar--6 {
  height: 4px;
  width: 4px;
  background: #000;
  display: inline-block;
  margin: 12px 2px;
  border-radius: 100%;
  -webkit-animation: loader 4s 0s infinite;
  animation: loader 4s 0s infinite;
  -webkit-animation-timing-function: cubic-bezier(0.03, 0.615, 0.995, 0.415);
  animation-timing-function: cubic-bezier(0.03, 0.615, 0.995, 0.415);
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.loader__bar--2 {
  -webkit-animation: loader 4s 0.2s infinite;
          animation: loader 4s 0.2s infinite;
}

.loader__bar--3 {
  -webkit-animation: loader 4s 0.4s infinite;
          animation: loader 4s 0.4s infinite;
}

.loader__bar--4 {
  -webkit-animation: loader 4s 0.6s infinite;
          animation: loader 4s 0.6s infinite;
}

.loader__bar--5 {
  -webkit-animation: loader 4s 0.8s infinite;
          animation: loader 4s 0.8s infinite;
}

.loader__bar--6 {
  -webkit-animation: loader 4s 1s infinite;
          animation: loader 4s 1s infinite;
}

@-webkit-keyframes loader {
  0% {
    -webkit-transform: translateX(-30px);
            transform: translateX(-30px);
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  50% {
    -webkit-transform: translateX(30px);
            transform: translateX(30px);
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}

@keyframes loader {
  0% {
    -webkit-transform: translateX(-30px);
            transform: translateX(-30px);
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  50% {
    -webkit-transform: translateX(30px);
            transform: translateX(30px);
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
.overlay {
  display: none;
}
</style>
